export const testimonials = [
  {
    id: 1,
    name: 'Sarah M.',
    role: '',
    content: 'Great overall experience and consistent quality. Everything arrived as expected, and the information provided was clear and easy to review. It\'s been a reliable option for our ongoing needs.',
    rating: 5,
    image: 'https://public.readdy.ai/ai/img_res/c98474521947dac066e5813d8fd2ca32.jpg'
  },
  {
    id: 2,
    name: 'James C.',
    role: '',
    content: 'Smooth ordering process, dependable delivery, and helpful support when questions came up. The consistency has made it easy to continue using their products with confidence.',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=professional%20man%20with%20warm%20smile%20in%20casual%20attire%20against%20soft%20neutral%20background%20simple%20clean%20portrait%20photography%20natural%20lighting&width=400&height=400&seq=testimonial-james-c&orientation=squarish'
  },
  {
    id: 3,
    name: 'Emily R.',
    role: '',
    content: 'We\'ve had a positive experience over time. The materials are well presented, and the transparency around testing and documentation provides added peace of mind.',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=professional%20woman%20with%20confident%20smile%20in%20casual%20business%20attire%20against%20soft%20neutral%20background%20simple%20clean%20portrait%20photography%20natural%20lighting&width=400&height=400&seq=testimonial-emily-r&orientation=squarish'
  }
];
